import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _createSuper from '@babel/runtime/helpers/esm/createSuper';
import { createRef, Component } from 'react';
import InfiniteCarousel from 'react-leaf-carousel';
import { isMobile } from '@dtvgo/utils';
import './Carousel.scss';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

var Carousel = /*#__PURE__*/function (_Component) {
  _inherits(Carousel, _Component);
  var _super = _createSuper(Carousel);
  function Carousel(props) {
    var _this;
    _classCallCheck(this, Carousel);
    _this = _super.call(this, props);
    _this.state = {
      firstCardHidden: false,
      initialPosition: true,
      leftArrowVisible: false,
      rightArrowVisible: false
    };
    _this.sliderRef = /*#__PURE__*/createRef();
    _this.onMouseOver = _this.onMouseOver.bind(_assertThisInitialized(_this));
    _this.onMouseLeave = _this.onMouseLeave.bind(_assertThisInitialized(_this));
    _this.prev = _this.prev.bind(_assertThisInitialized(_this));
    _this.next = _this.next.bind(_assertThisInitialized(_this));
    return _this;
  }

  /**
   * @method componentDidMount
   * @description React lifecycle method. Used to hide the first card when it is needed
   */
  _createClass(Carousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.shouldHideFirstCard()) {
        this.hideFirstCard();
      }
    }

    /**
     * @method componentDidUpdate
     * @description React lifecycle method. Used to hide the first card when it could not be hidden
     * @param {*} prevProps
     */
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        _this$props$children = _this$props.children,
        children = _this$props$children === void 0 ? [] : _this$props$children,
        slidesToShow = _this$props.sliderSettings.slidesToShow;
      var _prevProps$children = prevProps.children,
        prevChildren = _prevProps$children === void 0 ? [] : _prevProps$children,
        prevSlidesToShow = prevProps.sliderSettings.slidesToShow;
      var _this$state = this.state,
        initialPosition = _this$state.initialPosition,
        firstCardHidden = _this$state.firstCardHidden;
      if (prevChildren.length === 0 && children.length > 0 && !prevSlidesToShow && slidesToShow && this.shouldHideFirstCard() && initialPosition && !firstCardHidden) {
        this.hideFirstCard();
      }
    }

    /**
     * @description Method that handles mouse over.
     * @method onMouseOver
     */
  }, {
    key: "onMouseOver",
    value: function onMouseOver() {
      var initialPosition = this.state.initialPosition;
      var _this$sliderRef$curre = this.sliderRef.current.state,
        activePage = _this$sliderRef$curre.activePage,
        slidePages = _this$sliderRef$curre.slidePages;
      var _this$props2 = this.props,
        showSides = _this$props2.sliderSettings.showSides,
        infinitive = _this$props2.infinitive;
      if (infinitive) {
        if (this.isSingleSlider() || !initialPosition || !showSides) {
          this.showLeftArrow();
        }
        this.showRightArrow();
      } else {
        if (activePage + 1 < slidePages) {
          this.showRightArrow();
        }
        if (activePage > 0) {
          this.showLeftArrow();
        }
      }
    }

    /**
     * @description Method that handles mouse leave.
     * @method onMouseLeave
     */
  }, {
    key: "onMouseLeave",
    value: function onMouseLeave() {
      this.hideArrows();
    }

    /**
     * Method that returns the node corresponding to the incomplete first card on the left
     */
  }, {
    key: "getFirstCard",
    value: function getFirstCard() {
      var _this$props3 = this.props,
        children = _this$props3.children,
        slidesToShow = _this$props3.sliderSettings.slidesToShow;
      var slider = this.sliderRef.current.frame;
      if (slider) {
        var cards = slider.getElementsByTagName('li');
        // see the InfiniteCarousel card cloning logic in the library's code repo
        var firstCardIndex = children.slice(children.length - slidesToShow - 1, children.length).length - 1;
        return cards[firstCardIndex];
      }
      return null;
    }

    /**
     * Method that returns the node corresponding to the incomplete last card on the right
     */
  }, {
    key: "getLastCard",
    value: function getLastCard() {
      var _this$props4 = this.props,
        children = _this$props4.children,
        slidesToShow = _this$props4.sliderSettings.slidesToShow;
      var slider = this.sliderRef.current.frame;
      if (slider) {
        var cards = slider.getElementsByTagName('li');
        // see the InfiniteCarousel card cloning logic in the library's code repo
        var firstCardIndex = children.slice(children.length - slidesToShow - 1, children.length).length - 1;
        var lastCardIndex = firstCardIndex + (children.length + 1);
        return cards[lastCardIndex];
      }
      return null;
    }

    /**
     * @method isSingleSlider
     * @description Method that checks if the slider shows only one card
     */
  }, {
    key: "isSingleSlider",
    value: function isSingleSlider() {
      var slidesToShow = this.props.sliderSettings.slidesToShow;
      return slidesToShow === 1;
    }

    /**
     * @method shouldHideFirstCard
     * @description Method that checks if the first card should be hidden
     */
  }, {
    key: "shouldHideFirstCard",
    value: function shouldHideFirstCard() {
      var _this$props5 = this.props,
        _this$props5$children = _this$props5.children,
        children = _this$props5$children === void 0 ? [] : _this$props5$children,
        _this$props5$sliderSe = _this$props5.sliderSettings,
        slidesToShow = _this$props5$sliderSe.slidesToShow,
        showSides = _this$props5$sliderSe.showSides;
      return !this.isSingleSlider() && children.length > slidesToShow && showSides && !isMobile().any();
    }

    /**
     * @method hideFirstCard
     * @description Method that hides the incomplete first card on the left
     */
  }, {
    key: "hideFirstCard",
    value: function hideFirstCard() {
      var _this2 = this;
      // we need to delay this logic because it depends of an HTMLCollection that is not fill yet
      setTimeout(function () {
        var firstCard = _this2.getFirstCard();
        if (firstCard) {
          firstCard.classList.add('hidden-card');
          _this2.setState({
            firstCardHidden: true
          });
        }
      });
    }

    /**
     * @method hideLastCard
     * @description Method that hides the incomplete last card on the right
     */
  }, {
    key: "hideLastCard",
    value: function hideLastCard() {
      var lastCard = this.getLastCard();
      if (lastCard) {
        lastCard.classList.add('hidden-card');
      }
    }

    /**
     * @method showFirstCard
     * @description Method that shows the incomplete first card on the left
     */
  }, {
    key: "showFirstCard",
    value: function showFirstCard() {
      var firstCard = this.getFirstCard();
      if (firstCard) {
        firstCard.classList.remove('hidden-card');
        this.setState({
          firstCardHidden: false
        });
      }
    }

    /**
     * @method showLeftArrow
     * @description Method that shows left arrow.
     */
  }, {
    key: "showLeftArrow",
    value: function showLeftArrow() {
      this.setState({
        leftArrowVisible: true
      });
    }

    /**
     * @method showRightArrow
     * @description Method that shows right arrow.
     */
  }, {
    key: "showRightArrow",
    value: function showRightArrow() {
      this.setState({
        rightArrowVisible: true
      });
    }

    /**
     * @method hideArrows
     * @description Method that hides both arrows.
     */
  }, {
    key: "hideArrows",
    value: function hideArrows() {
      this.setState({
        leftArrowVisible: false,
        rightArrowVisible: false
      });
    }

    /**
     * @method toggleInitialPosition
     * @description Method that toggles initialPosition value in the component's state
     */
  }, {
    key: "toggleInitialPosition",
    value: function toggleInitialPosition() {
      this.setState(function (state) {
        return {
          initialPosition: !state.initialPosition
        };
      });
    }

    /**
     * @description Method that moves the slider to the left.
     * @method prev
     */
  }, {
    key: "prev",
    value: function prev(e) {
      var infinitive = this.props.infinitive;
      if (infinitive) {
        this.sliderRef.current.moveToPrevious(e);
      } else {
        var activePage = this.sliderRef.current.state.activePage;
        if (activePage > 0) {
          this.sliderRef.current.moveToPrevious(e);
          if (activePage === 1) {
            this.hideFirstCard();
            this.setState({
              leftArrowVisible: false
            });
          }
        }
      }
    }

    /**
     * @description Method that moves the slider to the right.
     * @method next
     */
  }, {
    key: "next",
    value: function next(e) {
      var infinitive = this.props.infinitive;
      var _this$state2 = this.state,
        firstCardHidden = _this$state2.firstCardHidden,
        initialPosition = _this$state2.initialPosition;
      if (initialPosition) {
        if (firstCardHidden && infinitive) this.showFirstCard();
        this.toggleInitialPosition();
      }
      if (infinitive) {
        this.sliderRef.current.moveToNext(e);
      } else {
        var _this$sliderRef$curre2 = this.sliderRef.current.state,
          activePage = _this$sliderRef$curre2.activePage,
          slidePages = _this$sliderRef$curre2.slidePages;
        if (activePage + 1 < slidePages) {
          this.sliderRef.current.moveToNext(e);
          if (activePage + 2 === slidePages) {
            this.hideLastCard();
            this.setState({
              rightArrowVisible: false
            });
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$state3 = this.state,
        leftArrowVisible = _this$state3.leftArrowVisible,
        rightArrowVisible = _this$state3.rightArrowVisible;
      // Destructuring only for sets default props.
      var _this$props6 = this.props,
        lazyLoad = _this$props6.lazyLoad,
        arrows = _this$props6.arrows,
        autoCycle = _this$props6.autoCycle,
        cycleInterval = _this$props6.cycleInterval,
        slidesSpacing = _this$props6.slidesSpacing,
        sideSize = _this$props6.sideSize,
        dots = _this$props6.dots,
        children = _this$props6.children,
        sliderSettings = _this$props6.sliderSettings,
        className = _this$props6.className,
        alignType = _this$props6.alignType;
      var settings = _objectSpread({
        cycleInterval: cycleInterval,
        autoCycle: autoCycle,
        lazyLoad: lazyLoad,
        dots: dots,
        arrows: arrows,
        slidesSpacing: slidesSpacing,
        sideSize: sideSize
      }, sliderSettings);
      return /*#__PURE__*/jsxs("div", {
        className: "dtv-slider-common ".concat(className),
        onMouseOver: this.onMouseOver,
        onMouseLeave: this.onMouseLeave,
        onFocus: function onFocus() {},
        children: [!isMobile().any() && children.length > settings.slidesToShow && /*#__PURE__*/jsxs(Fragment, {
          children: [leftArrowVisible && /*#__PURE__*/jsx("div", {
            className: "dtv-slider-arrow left",
            role: "button",
            tabIndex: -1,
            onKeyDown: function onKeyDown() {},
            onClick: function onClick(e) {
              return _this3.prev(e);
            },
            children: /*#__PURE__*/jsx("span", {
              className: "dtv-icon-arrow-back"
            })
          }), rightArrowVisible && /*#__PURE__*/jsx("div", {
            className: "dtv-slider-arrow right",
            role: "button",
            tabIndex: -1,
            onKeyDown: function onKeyDown() {},
            onClick: function onClick(e) {
              return _this3.next(e);
            },
            children: /*#__PURE__*/jsx("span", {
              className: "dtv-icon-arrow-foward"
            })
          })]
        }), children.length > 0 && /*#__PURE__*/jsx("div", {
          className: "dtv-container-slider ".concat(children.length <= settings.slidesToShow && alignType === 'center' ? 'dtv-container-center' : '').concat(children.length <= settings.slidesToShow && alignType === 'left' ? 'dtv-container-left' : ''),
          children: /*#__PURE__*/jsx(InfiniteCarousel, _objectSpread(_objectSpread({
            ref: this.sliderRef
            // eslint-disable-next-line react/jsx-props-no-spreading
          }, settings), {}, {
            children: children
          }))
        })]
      });
    }
  }]);
  return Carousel;
}(Component);
Carousel.defaultProps = {
  // Own props
  alignType: 'left',
  className: '',
  infinitive: true,
  sliderSettings: {},
  // InfiniteCarousel props
  lazyLoad: false,
  cycleInterval: 5000,
  slidesSpacing: 5,
  arrows: false,
  sideSize: 0.2,
  dots: false,
  autoCycle: false
};

export { Carousel as default };
//# sourceMappingURL=Carousel.js.map
